<template>
  <div class="card">
    <div class="loading card-title"></div>
    <div class="card-image loading"></div>
    <div class="loading card-description"></div>
  </div>
</template>

<script>
export default {
    name:"SkeletonProduct"
}
</script>

<style lang="scss">
.card {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: .5em;
  padding: 1em;
  border-radius: .5em;
  border: 1px solid #ddd;
  box-shadow: 0px 0px 4px #ddd;
}
.card-image.loading {
  width: 100%;
  flex: 1;
  min-height: 350px;
  margin: .5em;
}
.card-title {
  padding: 8px;
  font-size: 22px;
  font-weight: 700;
}
.card-title.loading {
  height: 1rem;
  border-radius: 3px;
  width: 60%;
}
.card-description {
  padding: 8px;
  font-size: 16px;
  width: 60%;
  align-self: flex-start;
}
.card-description.loading {
  height: 2rem;
  border-radius: 3px;
}

.loading {
  position: relative;
  background-color: #f5f5f5;
  overflow: hidden;
}
.loading::after {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateX(-100%);
  animation: 2s loading linear 0.5s infinite;
  background: linear-gradient(90deg, transparent, #ededed, transparent);
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  transform: translateX(-100%);
  z-index: 1;
}

@keyframes loading {
  0% {
    transform: translateX(-100%);
  }
  60% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@media (min-width: 1200px){
    .card-description{
      width: 45%;
    }
}
</style>